module.exports = __webpack_public_path__ + "static/media/bg.988fa4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/HJZ/bg.png
// module id = 460
// module chunks = 0